import { LineItem } from '@repo/ui/src/types/lineItem';
import Cookies from 'js-cookie';
import round from 'lodash/round';
import { track } from '@repo/ui/src/services/analytics/utils';
import { Order } from '@repo/ui/src/types';
import { orderCompleted } from '@repo/ui/src/services/analytics';
import { basketLineInputToAnalytics } from '@repo/ui/src/services/analytics/factories';

export const getOrderRevenue = (productItems: Array<LineItem>) =>
  productItems?.reduce((acc, { originalPrice }) => acc + originalPrice, 0) ?? 0;

export const getOrderDiscount = (productItems: Array<LineItem>) =>
  productItems?.reduce((acc, { discount }) => acc + round(discount ?? 0, 2), 0) ?? 0;

export const getOrderProducts = (productItems: Array<LineItem>) => [
  ...(productItems?.map((lineItem, i) => ({
    ...basketLineInputToAnalytics({
      ...lineItem,
      originalPrice: lineItem.basePrice, // confusing I know...
    }),
    position: i + 1,
  })) ?? []),
];

export const trackOrder = async (
  {
    details: {
      productItems,
      billingAddress,
      couponItems,
      currency,
      shippingTotal,
      taxTotal,
      orderTotal,
      orderNo,
      firstName,
      lastName,
      paymentInstruments,
      basketId,
      customerInfo,
    },
  }: Order,
  productGeo: 'CA' | 'US' = 'US',
) => {
  const revenue = getOrderRevenue(productItems);
  const gaClientId = Cookies.get('_ga');
  const gaSessionId = Cookies.get('_ga_VPQ1W61YCB');
  track(orderCompleted, {
    brand: `Traeger_${productGeo}`,
    billing_address_1: billingAddress.address1,
    billing_city: billingAddress.city,
    billing_state: billingAddress.stateCode,
    billing_zip_code: billingAddress.postalCode,
    billing_country: billingAddress.countryCode,
    coupon: couponItems?.map(({ code }) => code),
    currency: currency,
    discount: getOrderDiscount(productItems),
    email: customerInfo.email,
    checkout_id: basketId,
    ga_client_id: gaClientId?.split('.').slice(-2).join('.'),
    ga_session_id: gaSessionId?.split('.')[2],
    last_name: lastName,
    first_name: firstName,
    order_id: orderNo,
    payment_method: paymentInstruments?.map((payment) => payment.paymentCard?.cardType ?? 'other'),
    phone: billingAddress.phone,
    revenue,
    shipping: shippingTotal,
    tax: taxTotal,
    total: orderTotal,
    subtotal: revenue,
    products: getOrderProducts(productItems),
  });
};
